import { render } from "./DashboardFooter.vue?vue&type=template&id=48269a0c&scoped=true"
import script from "./DashboardFooter.vue?vue&type=script&lang=ts"
export * from "./DashboardFooter.vue?vue&type=script&lang=ts"

import "./DashboardFooter.vue?vue&type=style&index=0&id=48269a0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48269a0c"

export default script